<template>
    <div class="imageTranslationEditor"></div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api'
export default {
    name: 'ImageTranslationEditor',
    computed: {
        user(){
            const data = localStorage.getItem("data") ? JSON.parse(localStorage.getItem("data")) : {};
            return data.data.user;
        }
    },
    mounted() {
        this.loadIframe();
    },
    methods:{
        async getPermissions(telephone){
            const API = Baseurl + 'aidgeController/verifyPermissions'
            const res = await ajaxPost(API, {telephone});
            return res.data;
        },
        async loadIframe(){
            const permissions = await this.getPermissions(this.user.telephone);
            if(!permissions.data){
                const p = document.createElement('p');
                p.innerText = '无权限';
                p.style.textAlign = 'center';
                p.style.marginTop = '20px';
                p.style.fontSize = '20px';
                this.$el.appendChild(p);
                return
            }
            const translateParam = {
                api: "/ai/image/translation",
                apiHost: 'aibcn',
                params: {
                    imageUrl: "",
                    sourceLanguage: 'zh',
                    targetLanguage: 'en',
                    apiHost: 'aib',
                }
            };
            const payloadString = encodeURIComponent(JSON.stringify(translateParam));
            const sceneURL = 'https://image-editor.aidc-ai.com/editor/index.html/#/translate';
            const iframeURL = `${sceneURL}?payload=${payloadString}`;

            const iframe = document.createElement('iframe');
            iframe.className = 'aidc-open-frame';
            iframe.src = iframeURL;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.frameBorder = '0';
            this.$el.appendChild(iframe);
        }
    }
}
</script>

<style scoped>
.imageTranslationEditor {
    width: 100%;
    height: 100vh;
}
</style>